import type { DataBlock, IconDataSpan } from 'de-zurich-ui-library'
import type { DataBlockArrayCreator } from '@/utils/shur/SHURDataBlockCreator'
import { type Contract, TRKeys, type TRLine } from 'shur-api'
import { fallbackNoDetailsAvailableDataSection } from '@/utils/shur/SHUREmptyDataCreator'
import { t } from '@/i18n'

export class DataTransportCostCreator implements DataBlockArrayCreator {
  createDatablockArray(contract: Contract): DataBlock[] {
    return [createTransportGlobalData(contract)]
  }
}

const insuredBenefitsInfoIconData: IconDataSpan = {
  iconClass: 'icon-vorteile',
  href: 'openModal_insuredBenefitsInfo',
  isRouterLink: false
}

// Versicherungsumfang
function createTransportGlobalData(contract: Contract): DataBlock {
  let trLine: TRLine = { productSubType: 'TRAVEL_COST', details: [] }
  contract.trLine?.forEach((line) => (trLine = line))

  if (!trLine.details || trLine.details.length === 0)
    return fallbackNoDetailsAvailableDataSection()

  const contractDetailsCodeValuePairs = trLine.details

  return <DataBlock>{
    title: {
      label:
        t('shurDetails.sections.TRAVEL.SCOPE_OF_INSURANCE.title') ??
        'shurDetails.sections.TRAVEL.SCOPE_OF_INSURANCE.title'
    },
    data: [
      {
        label: t(`shurDetails.sections.TRAVEL.SCOPE_OF_INSURANCE.contractType`),
        value: contractDetailsCodeValuePairs.find(
          (entry) => entry.key === TRKeys.ContractType
        )?.value
      },
      {
        label: t(`shurDetails.sections.TRAVEL.SCOPE_OF_INSURANCE.outwardJourneyDate`),
        value: contractDetailsCodeValuePairs.find(
          (entry) => entry.key === TRKeys.OutwardJourneyDate
        )?.value
      },
      {
        label: t(`shurDetails.sections.TRAVEL.SCOPE_OF_INSURANCE.returnJourneyDate`),
        value: contractDetailsCodeValuePairs.find(
          (entry) => entry.key === TRKeys.ReturnJourneyDate
        )?.value
      },
      {
        label: t(`shurDetails.sections.TRAVEL.SCOPE_OF_INSURANCE.deductible`),
        value: contractDetailsCodeValuePairs.find(
          (entry) => entry.key === TRKeys.Deductible
        )?.value
      },
      {
        label: t(`shurDetails.sections.TRAVEL.SCOPE_OF_INSURANCE.insuredAmount`),
        value:
          contractDetailsCodeValuePairs.find(
            (entry) => entry.key === TRKeys.InsuredAmount
          )?.value +
          ' ' +
          contractDetailsCodeValuePairs.find((entry) => entry.key === TRKeys.CurrencyCode)
            ?.value
      },
      {
        label: t(`shurDetails.sections.TRAVEL.SCOPE_OF_INSURANCE.insuredBenefitsTitle`),
        value: t(`shurDetails.sections.TRAVEL.SCOPE_OF_INSURANCE.moreInfo`),
        iconSpan: insuredBenefitsInfoIconData
      },
      {
        label: t(`shurDetails.sections.TRAVEL.SCOPE_OF_INSURANCE.territoryTitle`),
        value: t(`shurDetails.sections.TRAVEL.SCOPE_OF_INSURANCE.territoryText`)
      },
      {
        label: t(`shurDetails.sections.TRAVEL.SCOPE_OF_INSURANCE.insuredPersonsTitle`),
        value: t(`shurDetails.sections.TRAVEL.SCOPE_OF_INSURANCE.insuredPersonsText`)
      },
      {
        label: t(
          `shurDetails.sections.TRAVEL.SCOPE_OF_INSURANCE.extraInsuredPersonsTitle`
        ),
        value: t(`shurDetails.sections.TRAVEL.SCOPE_OF_INSURANCE.extraInsuredPersonsText`)
      }
    ]
  }
}
